module.exports = function(app) {
	'use strict';
	app.directive('eprMajorMedical', function() {
		return {

			template: require('directives/employee/eprMajorMedical.html'),
			restrict: 'A',
			replace: false,

			scope: {
				employee: '=eprMajorMedical',
				groupNumber: '=',
				coverageEffectiveDate: '=',
				zipCode: '=?'
			},

			controller: ['$scope', '$filter', '$q', 'coverageBuddy', 'employee', 'addFlowCommander',
				function($scope, $filter, $q, coverageBuddy, employee, addFlowCommander) {

					var allParticipants = [$scope.employee.data.subscriber].concat($scope.employee.data.dependents);

					$scope.isInAddFlow = addFlowCommander.isInAddFlow();

					$scope.$watch('groupNumber', function() {
						if ($scope.groupNumber) {
							coverageBuddy.getAvailableProductsFor(
								{
									coverageType: 'medical',
									effectiveDate: $scope.coverageEffectiveDate instanceof Date ? formatDate($scope.coverageEffectiveDate): formatDate($scope.coverageEffectiveDate),
									zipCode: $scope.zipCode,
									groupNumber: $scope.groupNumber
								}, employee.data
							).then(
								function(products) {
									if (products && products.length > 1) {
										$scope.coverageMap = getCoverageMap(products, allParticipants);
										defineBeforeSubmitHook($scope.coverageMap, allParticipants, $scope.groupNumber);
									}
									else {
										$scope.coverageMap = null;
									}
								}
							);
						}
						else {
							$scope.coverageMap = null;
						}
					});

					$scope.$on('updateMajorMedical', function() {
						if ($scope.applyMajorMedicalSelections && $scope.applyMajorMedicalSelections instanceof Function) {// if MM was inapplicable, this would never have been defined
							if (addFlowCommander.isInAddFlow()) {
								return $scope.applyMajorMedicalSelections();
							}
							else {
								$scope.applyMajorMedicalSelections().then(
									function() { $scope.$emit('majorMedicalUpdated', true); },
									function() { $scope.$emit('majorMedicalUpdated', false); }
								);
							}
						}
						else {
							$scope.$emit('majorMedicalUpdated', true);
						}
					});

					$scope.cascadeSubscriberDeselection = function(participants) {
						Object.keys(participants[0].selectionMap).forEach(function(line) {
							participants.forEach(function(p, i) {
								if (!participants[0].selectionMap[line] && i > 0) {
									p.selectionMap[line] = false;
								}
							});
						});
					};


					function formatDate(date) {
						return $filter('date')(date, 'MM-dd-yyyy');
					}


					function getEmployeeDataParticipant(coverageMapParticipant, allParticipants) {
						var participant;
						for (var i = 0; i < allParticipants.length; ++i) {
							participant = allParticipants[i];
							if (
								coverageMapParticipant.displayName === employee.getDisplayName(participant) &&
								formatDate(coverageMapParticipant.birthDate) === formatDate(participant.birthDate)
							) {
								return participant; // at which point 'participant' is now assigned correctly
							}
						}
					}


					function getCoverageMap(products, participants) {
						products = angular.copy(products);
						participants = angular.copy(participants);

						function mapCoverageParticipants(ps) {
							return ps.map(function(p) {
								return {
									displayName: employee.getDisplayName(p),
									birthDate: p.birthDate,
									relationshipCode: p.relationshipCode,
									selectionMap: {}
								};
							});
						}

						function assignExistingSelections(coverageMapParticipants, coverageMapProducts) {
							coverageMapParticipants.forEach(function(p) {
								var participant = getEmployeeDataParticipant(p, allParticipants);
								var group = coverageBuddy.getCoverageByGroupNumber(participant, $scope.groupNumber);
								coverageMapProducts.forEach(function(lob) {
									p.selectionMap[lob.lineOfBusiness] = group && Boolean(coverageBuddy.getLobByLineOfBusiness(group, lob.lineOfBusiness));
								});
							});
						}

						function buildAddFlowParticipants() {
							return mapCoverageParticipants(allParticipants.filter(function(p) {
								return Boolean(
									coverageBuddy.getCoverageByGroupNumber(p, $scope.groupNumber) &&
									coverageBuddy.isGroupActive(p, $scope.groupNumber)
								);
							}));
						}

						function buildEditFlowParticipants(coverageMapParticipants, coverageMapProducts) {
							$scope.planCoverageOptIn = employee.metadata.planCoverageOptIn;

							$scope.$watch('planCoverageOptIn', function(n) {
								if (n && n.subscriber) {
									if (n.subscriber.medical) {
										var participantIndices = [0];
										for (var i = 0; i < n.dependents.length; ++i) {
											if (n.dependents[i].medical) {
												(function(j) {
													participantIndices.push(j);
												}(i+1));
											}
										}
										while (coverageMapParticipants.length) {
											coverageMapParticipants.pop();
										}
										participantIndices.forEach(function(i) {
											coverageMapParticipants.push(mapCoverageParticipants([allParticipants[i]])[0]);
										});
										assignExistingSelections(coverageMapParticipants, coverageMapProducts);
									}
									else {
										while (coverageMapParticipants.length) {
											coverageMapParticipants.pop();
										}
									}
								}
							}, true);
						}

						var coverageMapParticipants = [];

						var coverageMapProducts = products.map(function(lob) {
							lob.lineOfBusiness = lob.icisProductType;
							lob.coverageEffectiveDate = lob.coverageEffectiveDate
								? lob.coverageEffectiveDate
								: new Date($scope.coverageEffectiveDate);
							return lob;
						});

						if (addFlowCommander.isInAddFlow()) {
							$scope.participantIsAreadyEnrolled = function() { return false; };
							coverageMapParticipants = buildAddFlowParticipants();
							assignExistingSelections(coverageMapParticipants, coverageMapProducts);
						}
						else {
							buildEditFlowParticipants(coverageMapParticipants, coverageMapProducts);
						}

						return {
							products: coverageMapProducts,
							participants: coverageMapParticipants,
							getProductByLineOfBusiness: function(lineOfBusiness) {
								return this.products.filter(
									function(lob) { return lob.lineOfBusiness === lineOfBusiness; }
								)[0];
							}
						};
					}


					function defineBeforeSubmitHook(coverageMap, allParticipants, groupNumber) {
						$scope.$parent.applyMajorMedicalSelections = $scope.applyMajorMedicalSelections = function() {
							var deferred = $q.defer();

							if (nothingIsSelected()) {
								coverageBuddy.showCoverageModal('noProductSelected', $scope.$new());
								deferred.reject();
							}

							function nothingIsSelected() {
								return !coverageMap.participants.some(function(p) {
									return Object.keys(p.selectionMap).filter(function(product) {
										return p.selectionMap[product];
									}).length;
								});
							}

							(function setCoverageCategoryCodes() {
								coverageMap.products.forEach(function(lob) {
									var categoryCodeMap = coverageBuddy.getNewCategoryCodeMap();
									coverageMap.participants.forEach(function(p) {
										if (p.selectionMap.hasOwnProperty(lob.lineOfBusiness) && p.selectionMap[lob.lineOfBusiness]) {
											coverageBuddy.updateCategoryCodeMap(categoryCodeMap, p.relationshipCode);
										}
									});
									lob.coverageCategoryCode = coverageBuddy.getCoverageCategoryCodeFromMap(categoryCodeMap);
								});
							}());

							(function fillMemberLobs() {
								coverageMap.participants.forEach(
									function(p) {
										var participant = getEmployeeDataParticipant(p, allParticipants);
										var group = coverageBuddy.getCoverageByGroupNumber(participant, groupNumber);

										coverageMap.products.forEach(function(product) {
											coverageBuddy.removeLobFromGroup(group, product.lineOfBusiness);
										});
										Object.keys(p.selectionMap).filter(
											function(lineOfBusiness) {
												return p.selectionMap[lineOfBusiness];
											}
										).forEach(
											function(lineOfBusiness) {
												var lob = coverageMap.getProductByLineOfBusiness(lineOfBusiness);
												group.memberLobs.push({
													lineOfBusiness: lob.icisProductType,
													coverageEffectiveDate: $filter('date')(lob.coverageEffectiveDate, 'MM/dd/yyyy'),
													coverageCategoryCode: lob.coverageCategoryCode,
													productId: lob.productId,
													coverageType: 'MEDICAL'
												});
											}
										);
									}
								);
								deferred.resolve();
							}());

							return deferred.promise;
						};
					}
				}
			]
		};
	});
};
